import React, { useState } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Rating,
    IconButton,
    CardActionArea,
    useMediaQuery,
    Button
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link, useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Slider from 'react-slick';
import Authorize from '../Authorize';
import * as Roles from '../../resources/UserRole';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RelatedProducts = ({ products, cartActions, localized, selectedCustomer, cartLines, maxLines }) => {
    const theme = useTheme();
    const history = useHistory();

    const handleCardClick = (product) => {
        history.push(`/product/${product.sku}`, { state: { selectedCustomer } });
    };

    const handleCartClick = (event, product) => {
        event.stopPropagation();
        const item = { product: product, quantity: 1 };
        cartActions.AddItemToCart(item, localized);
    };

    const SlickArrow = ({ direction, onClick }) => (
        <IconButton
            onClick={onClick}
            sx={{
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: theme.shadows[2],
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                },
                ...(direction === 'left'
                    ? { left: -16 }
                    : { right: -16 }),
            }}
        >
            {direction === 'left' ? <ChevronLeftIcon size={20} /> : <ChevronRightIcon size={20} />}
        </IconButton>
    );

    const slides = products.length > 5 && products.length < 12 ? products.length / 2 : 5; 
    const infinite = products?.length < 5 ? false : true;
    const sliderSettings = {
        dots: false,
        infinite: infinite,
        slidesToShow: slides,
        speed: 500,
        slidesToScroll: 1,
        infinite: infinite,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: <SlickArrow direction="left" />,
        nextArrow: <SlickArrow direction="right" />,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    return (
        <Box sx={{ mt: 3, mx: { xs: 0, sm: 2 }, width: "80%" }}>
            <Typography variant="h5" component="h2" fontWeight={600} gutterBottom>
                {localized.RelatedItemsHeader}
            </Typography>
            <Slider {...sliderSettings}>
                {products.map((product) => (
                    <Box key={product.id} sx={{ px: 1 }}>
                        <Card
                            onClick={() => handleCardClick(product)}
                            sx={{
                                height: '100%',
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: theme.shadows[6],
                                }
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="200"
                                image={`${product.imageUrl}300x250px@1x/${product.sku}.jpg?q=80&x.template=y&crop=false`}
                                alt={product.name}
                                sx={{ objectFit: 'contain' }}
                            />
                            <CardContent sx={{ height: 180, overflow: 'hidden' }}>
                                <Typography variant="h6" component="h3" noWrap>
                                    {product.sku}
                                </Typography>
                                <Typography variant="h6" component="h3" noWrap>
                                    {product.name}
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        mt: 1,
                                        height: 40, 
                                        overflow: 'hidden'
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            ml: 0.5,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            width: '100%'
                                        }}
                                    >
                                        ({product.description})
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4 }}>
                                    <Typography variant="h6" component="div" fontWeight={600}>
                                        {product.associationType}
                                    </Typography>
                                    {(selectedCustomer.addressType == 0 || selectedCustomer.addressType == 2 || selectedCustomer.addressType == 3) &&
                                        <Authorize hasRoles={[Roles.PLACE_ORDERS]} displayMessage={false}>
                                            {cartLines < maxLines ? (
                                                <Box className="button-wrapper add-to-order">
                                                    <Button
                                                        sx={{ padding: "10px" }}
                                                        className="button"
                                                        onClick={(e) => handleCartClick(e, product)}
                                                    >
                                                        {localized.ButtonText_AddToOrder}
                                                    </Button>
                                                </Box>
                                            ) : (
                                                <Box style={{ whiteSpace: 'nowrap', fontSize: 'large', marginTop: '4px' }}>
                                                    <FontAwesomeIcon icon={faExclamationTriangle} color="orange" /> {localized.CartMaxLines}
                                                </Box>
                                            )}
                                        </Authorize>
                                    }
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};


export default RelatedProducts;